export default {
    th: 'th',
    en: 'en',
}
